import type { ForgePageName } from './types';

// JSM portal/help-center page name constants
export const FORGE_HELP_CENTER: ForgePageName = 'help_center';
export const FORGE_PORTAL_HOME: ForgePageName = 'portal';
export const FORGE_REQUEST_CREATE: ForgePageName = 'create_request';
export const FORGE_REQUEST_DETAILS: ForgePageName = 'view_request';
export const FORGE_REQUEST_LIST: ForgePageName = 'my_requests';
export const FORGE_PROFILE: ForgePageName = 'profile';

// CSM (Customer Service Management) page name constants
export const FORGE_CSM_REQUEST_DETAILS: ForgePageName = 'csm_view_request';

export const REQUEST_DETAIL_MAIN_SECTION_MODULE = 'jiraServiceManagement:portalRequestDetail';
export const REQUEST_DETAIL_SIDE_SECTION_MODULE = 'jiraServiceManagement:portalRequestDetailPanel';
export const PORTAL_HEADER_MODULE = 'jiraServiceManagement:portalHeader';
export const PORTAL_FOOTER_MODULE = 'jiraServiceManagement:portalFooter';
export const PORTAL_SUBHEADER_MODULE = 'jiraServiceManagement:portalSubheader';
export const PROFILE_PANEL_MODULE = 'jiraServiceManagement:portalProfilePanel';
export const USER_MENU_ACTION_SECTION_MODULE = 'jiraServiceManagement:portalUserMenuAction';
export const REQUEST_VIEW_ACTION_MODULE = 'jiraServiceManagement:portalRequestViewAction';
export const PORTAL_REQUEST_CREATE_PROPERTY_PANEL_MODULE =
	'jiraServiceManagement:portalRequestCreatePropertyPanel';
export const HELP_CENTER_LAYOUT_ELEMENT_MODULE = 'jiraServiceManagement:helpCenterLayoutElement';
export const CSM_REQUEST_DETAIL_MODULE = 'customerServiceManagement:requestDetail';
export const CUSTOM_FIELD = 'jira:customField';
export const CUSTOM_FIELD_TYPE = 'jira:customFieldType';
export const UI_MODIFICATIONS = 'jira:uiModifications';

export const JIRA_MODULES = [CUSTOM_FIELD, CUSTOM_FIELD_TYPE, UI_MODIFICATIONS];

export const USER_MENU_ACTION_COMPONENT = 'PortalUserMenuAction';
export const REQUEST_VIEW_ACTION_COMPONENT = 'PortalRequestViewAction';

export const RESOURCE_TYPE_ISSUE = 'ISSUE';
export const RESOURCE_TYPE_PROJECT = 'PROJECT';

export const RESOURCE_TYPE_UNKNOWN = 'UNKNOWN';

export const TOP_LEVEL_COMPONENTS = {
	[REQUEST_DETAIL_MAIN_SECTION_MODULE]: 'PortalRequestDetail',
	[REQUEST_DETAIL_SIDE_SECTION_MODULE]: 'PortalRequestDetailPanel',
	[PORTAL_HEADER_MODULE]: 'PortalHeader',
	[PORTAL_FOOTER_MODULE]: 'PortalFooter',
	[PORTAL_SUBHEADER_MODULE]: 'PortalSubheader',
	[PROFILE_PANEL_MODULE]: 'PortalProfilePanel',
	[PORTAL_REQUEST_CREATE_PROPERTY_PANEL_MODULE]: 'PortalRequestCreatePropertyPanel',
	[CSM_REQUEST_DETAIL_MODULE]: 'CsmRequestDetail',
};

export const ENTRY_POINT_EDIT = 'edit';
